import {
  Dropdown as FluentDropdown,
  DropdownProps,
  Option,
  OptionOnSelectData,
} from "@fluentui/react-components";

export interface IDropdownOption {
  key: string | number; // backend id
  text: string; // display text
}

export interface IDropdownProps
  extends Omit<DropdownProps, "onOptionSelect" | "children" | "value"> {
  options: IDropdownOption[];
  value?: string | number;
  handleChange: (key: any, option?: OptionOnSelectData) => void;
  label?: string;
}

export const mapToOptions = <T,>(
  arr: T[],
  keyField: keyof T,
  textField: keyof T
): IDropdownOption[] =>
  arr.map((item) => ({
    key: String(item[keyField]),
    text: String(item[textField]),
  }));

const Dropdown: React.FC<IDropdownProps> = ({
  options,
  value,
  handleChange,
  placeholder = "Select an option",
  disabled,
  label,
  id,
  appearance = "filled-darker",
  ...rest
}) => {
  const handleSelect: DropdownProps["onOptionSelect"] = (_, data) => {
    if (data.optionValue) {
      handleChange(data.optionValue, data);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      {label && <label htmlFor={id}>{label}</label>}
      <FluentDropdown
        id={id}
        value={options.find((o) => o.key === value)?.text ?? ""}
        selectedOptions={value ? [String(value)] : []}
        onOptionSelect={handleSelect}
        placeholder={placeholder}
        disabled={disabled}
        appearance={appearance}
        {...rest}
      >
        {options.map((option) => (
          <Option key={option.key} value={String(option.key)}>
            {option.text}
          </Option>
        ))}
      </FluentDropdown>
    </div>
  );
};

export default Dropdown;
